module.exports = __webpack_public_path__ + "img/0Q3A0072_L_Black.dfa5f367.jpg";